import { Assistant, ChatMessage } from "../../../shared/models";
// import { useDebugMessage } from "./useDebugMessage";
import { useMessageBody } from "./useMessageBody";
import { useSuggestedActions } from "./useSuggestedActions";

interface UseMessageItemProps {
    userName: string;
    readonly: boolean;
    responseInProgress: boolean;
    debug: boolean;
    sendMessage: (message: string) => void;
    handleSessionComplete: () => void;
    assistant?: Assistant;
}

export const useMessageItem = ({
    userName,
    readonly,
    responseInProgress,
    debug,
    sendMessage,
    handleSessionComplete,
    assistant
}: UseMessageItemProps) => {
    // const { renderDebugMessage } = useDebugMessage();
    const { renderMessageBody } = useMessageBody({ userName, responseInProgress, debug });
    const { renderSuggestions } = useSuggestedActions({ sendMessage, assistant, handleSessionComplete });

    const renderMessageItem = (message: ChatMessage) => (
        <span key={message.id}>
            {renderMessageBody(message)}
            {!readonly && !responseInProgress && renderSuggestions(message)}
            {/* {debug && renderDebugMessage(message)} */}
        </span>
    );

    return { renderMessageItem };
}; 